export default "__VITE_ASSET__DzNcPgwJ__"